/*
This file is located in the main branch
Last time the file was updated (UTC): [19.08.2024 14:24:30]
Permissions to update outside the main branch: [true]
*/

import { Auth } from 'models/auth';
import { useContext } from 'react';
import AuthContext from '../providers/AuthProvider';

export const initialAuth: Auth = {
    user: null,
    userFullName: null,
    userId: null,
    roles: null,
    apiCrmToken: null,
    accessTokenExpires: null,
    accessTokenValid: false,
    tariffEditingAccess: null,
    tariffEditableBillServices: null,
    canViewOrdersWithActiveProlongationAgreements: false,
    portalUserEmployerId: null,
    showMerchantInstruction: false,
    userStartPage: null,
};

const useAuth = () => {
    return useContext(AuthContext);
};

export default useAuth;
